export default __webpack_public_path__ + "static/media/fauna-demo-data.e3bf1b5a.png";